import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../types';

export const tiktokStaticData = {
  menuTitle: MenuTitle.TikTok
};

export const Route = createFileRoute('/_private-routes/hashtag-analytics/tiktok')({
  staticData: tiktokStaticData
});
